import React from 'react';
import './Partners.css';

const Partners = () => {
  const partners = [
    '合作伙伴1', '合作伙伴2', '合作伙伴3', '合作伙伴4', '合作伙伴5', '合作伙伴6'
  ];

  return (
    <section className="partners-section">
      <div className="container">
        <h2 className="section-title">合作伙伴</h2>
        <p className="section-subtitle">携手共进，合作共赢</p>
        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div key={index} className="partner-item">
              <div className="partner-logo">
                {partner}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;



